import React, { useRef, useState } from "react";
import Header from "../common/Header";
import Footer from "../common/Footer";
import emailjs from "emailjs-com";
import addressIcon from "../../assets/image/svg/addresIcon.svg";
import phoneIcon from "../../assets/image/svg/phoneIcon.svg";
import smsIcon from "../../assets/image/svg/smsIcon.png";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactUs = () => {
    window.scrollTo(0, 0);
  const form = useRef();
  const [loading, setLoading] = useState(false); // ✅ loading state

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true); // start loading

    emailjs
      .sendForm(
        "service_2fb2sd7", 
        "template_o4mf6kt", 
        form.current,
        "Td8Hm_0w6K0_wb0Ts" 
      )
      .then(
        (result) => {
          console.log("Success:", result.text);
          toast.success("Message sent successfully! 🚀");
          form.current.reset();
          setLoading(false); // stop loading
        },
        (error) => {
          toast.error("Failed to send message. Please try again ❌");
          console.error("FAILED...", error.text);
          setLoading(false); // stop loading
        }
      );
  };

  return (
    <div >
      <Header />
      <ToastContainer />
      <div className="bg-light">
      <div className="container d-flex align-items-center  py-5">
        <div className="container py-4">
          <div className="row items-center g-5">
            {/* Left Side - Contact Info */}
            <div className="col-md-6 d-flex flex-column justify-content-center">
              <p className="text-uppercase clr mb-0 fw-semibold">
                Send us a message
              </p>
              <h1 className="fw-bold fs_48 display-6">
                Get in <span>touch</span> With Us Today
              </h1>
              <p className="text-muted">
                Get in touch with us to discuss your ideas and see how Vasta can help bring them to life. Our team is ready to assist you with any questions or projects.
              </p>

              <div className="mt-4 d-flex flex-column gap-3">
                <div className="d-flex align-items-center gap-3">
                  <img src={addressIcon} width={40} height={40} alt="addressIcon" />
                  <div>
                    <p className="text-muted small mb-0">Address</p>
                    <p className="fw-semibold mb-0">Vasta HQ, Dubai, UAE</p>
                  </div>
                </div>
                {/* <div className="d-flex mt-3 align-items-center gap-3">
                  <img src={phoneIcon} width={40} height={40} alt="phoneIcon" />
                  <div>
                    <p className="text-muted small mb-0">Mobile No</p>
                    <p className="fw-semibold mb-0">+91 88089 88997</p>
                  </div>
                </div> */}
                <div className="d-flex mt-3 align-items-center gap-3">
                  <img src={smsIcon} width={40} height={40} alt="smsIcon" />
                  <div>
                    <p className="text-muted small mb-0">Email</p>
                    <p className="fw-semibold mb-0">joshua@vasta.ae</p>
                    <p className="fw-semibold mb-0">adnan@vasta.ae</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side - Contact Form */}
            <div className="col-md-6">
              <p className="fw-medium text-dark mb-3">
                Fill up the Form for sending message
              </p>
              <form ref={form} onSubmit={sendEmail} className="row g-3">
                <div className="col-md-6">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Name"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Email"
                    required
                  />
                </div>
                <div className="col-12">
                  <select name="subject" className="form-select" required>
                    <option value="">Subject</option>
                    <option value="general">General Inquiry</option>
                    <option value="support">Support</option>
                  </select>
                </div>
                <div className="col-12">
                  <textarea
                    name="message"
                    className="form-control"
                    rows="8"
                    placeholder="Type here !"
                    required
                  ></textarea>
                </div>
                <div className="col-12">
                  <button
                    type="submit"
                    className="text-white px-4 fw-medium rounded-2 py-2 border-0 bg640D5F d-flex align-items-center justify-content-center"
                    disabled={loading} // disable when loading
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Sending...
                      </>
                    ) : (
                      "Send Message"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactUs;
